import { createContext } from "react";

export const LolContext = createContext({});

export default LolContext;
